import { keyframes, styled } from '@/stitches.config';

import { Box } from '@base-app';
import { ReactComponent as HelixLogo } from '@assets/helix.svg';

export const fadeAnimation = keyframes({
  '0%': { opacity: 0 },
  '50%': { opacity: 1 },
  '100%': { opacity: 0 },
});

export const FadeAnimationContainer = styled(Box, {
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
});

export const StyledLogo = styled(HelixLogo, {
  height: '500px',
  width: '500px',
});
